module.exports = __webpack_public_path__ + "img/history_icon.0479c2c2.svg";